export default __webpack_public_path__ + "static/media/0x0e98c977b943f06075b2d795794238fbfb9b9a34.8c44e72a.webp";